// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl: "https://tpapublisherapistage.kaz.com.bd/api/", //Stage
  baseUrl: "https://tpapublisherapistage.kaz.com.bd/api/", //Live
  analyzer: {
    baseUrl: "https://tpapublisherapistage.kaz.com.bd/api/", // Stage
    // baseUrl: "https://analyzerrctpaapi.reganalytics.com/api/", // Live
    // baseUrl: 'https://localhost:5002/api/' //Local
  },
  others: {
    rfNewsUrl: "https://regplusstage.kaz.com.bd/api/",
  },
  // baseUrl: 'https://analyzertpapublisher.reganalytics.com/api/' //Analyzer
  // baseUrl: 'https://localhost:5001/api/' //Local
  SYNCFUSION_API_KEY:
    "Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXteeXRTQ2BfVEB0VkFWYEo=",
};

export const sourceCaseLawFileBucketName = "regpluscontent";

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
